import { useState } from "react";

import { useDashboardBrandingContext } from "./context";

interface BrandedLogoProps {
  height?: number;
  width?: number;
}

/**
 * The client's logo when the enclosing dashboard has one, otherwise the AGAVE mark.
 *
 * Falls back to AGAVE whenever the client logo fails to load. A broken image on a
 * client-facing dashboard looks worse than showing the vendor mark, and `logoUrl` points
 * at a third-party host we do not control.
 */
export function BrandedLogo({ height = 32, width }: BrandedLogoProps) {
  const branding = useDashboardBrandingContext();
  const [failed, setFailed] = useState(false);
  const logoUrl = branding?.logoUrl;

  // Render nothing rather than the AGAVE mark: this sits next to the dashboard title, and
  // stamping the vendor badge onto every unbranded dashboard would be noise. Callers that
  // want a guaranteed logo (nav, loading screen) use DefaultLogoIcon directly.
  if (!logoUrl || failed) {
    return null;
  }

  return (
    <img
      src={logoUrl}
      alt=""
      height={height}
      style={{ height, width: width ?? "auto", objectFit: "contain" }}
      onError={() => setFailed(true)}
      data-testid="agavepulse-client-logo"
    />
  );
}
